namespace JupitersChoice {
    export class DoFreeGameLightningStrikesOnReelsCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('GameConfig') _gameConfig: Sapphire.GameConfig;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('ResponseHelper') _responseHelper: ResponseHelper;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            const grids = this._gameConfig.get('external', 'grids');
            const reels = this._componentManager.get('Reels');
            const spinInfo = response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1];
            const reelsetType = grids[spinInfo.grid].reels;
            const lockedReels = this._responseHelper.getLockedReels(spinInfo.lockedWithPreviousReel);

            lockedReels.forEach(idx => {
                this._componentManager.get(`FreeGameReelCrumbleIntro${idx}`).play(() => {
                    this._componentManager.get(`FreeGameReelCrumbleLoop${idx}`).play();
                });

                let blt2 = this._componentManager.get(`FreeGameBolt${idx}`);

                blt2.reset();
                blt2.setOnComplete(() => { blt2.hide(); });
                blt2.play();

                reels.updateStrips([idx], reelsetType[spinInfo.rawReelIndices[idx]], true);
            });
            this._soundManager.play('lightning_02',null,AudioConstants.LOCK_LIGHTNING_VOLUME);
        }
    }
}